module.exports = __webpack_public_path__ + "media/budapest/budafpest-eab5605b.jpg";